export const SCREEN_WIDTH = 174;
export const SCREEN_HEIGHT = 174;
